import { api } from "@/lib/api";
import { ApiResponse, SubscriptionSummary } from "@/lib/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useGetSubscriptionSummary = (
  options?: Omit<
    UseQueryOptions<ApiResponse<SubscriptionSummary>>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery<ApiResponse<SubscriptionSummary>>({
    queryKey: ["subscription-summary"],
    queryFn: async () => {
      const response = await api.get("/organizations/subscription-summary");
      return response.data;
    },
    ...options,
  });
};
